import type { AppUrlResponse } from '~/server/api/apps/url/[app_id]'
import type { AppUrlPageLocation, AppUrlType } from '~/types/product.model'

/**
 * Fetch the App URL and open the link in a new tab
 */
export const getAppUrlAndRedirect = async (
  appId: string, urlType: AppUrlType, pageLocation: AppUrlPageLocation,
): Promise<void> => {
  const appUrlData = await $fetch<AppUrlResponse>(
    `/api/apps/url/${appId}`, { query: {
      url_type: urlType,
      page_location: pageLocation,
    } },
  )
  window.open(appUrlData.url, '_blank')
}
